import { isString } from 'lodash';
import { Component, ReactElement, ReactNode, useContext } from 'react';
import ArrowPointLeftIcon from '@shared/assets/icons/v2/arrow-point-left.svg';
import DotsIcon from '@shared/assets/icons/v2/dots.svg';
import { MBImageURISource } from '@shared/components/image';
import { MBSeparator } from '@shared/components/list/separator';
import { MBTextH4 } from '@shared/components/typography';
import { ColorThemeContext } from '@shared/styles';
import classNames from './NavHeader.module.css';
import { MBNavigationHeaderButton } from './headerButton';

export interface MobileNavHeaderProps {
  title?: ReactNode;
  leftIcon?: MBImageURISource;
  rightIcon?: MBImageURISource;
  separator?: boolean;
  rightButton?: ReactElement;
  onPressLeft?(node: Component): void;
  onPressRight?(node: Component): void;
}

export function NavHeader({
  title,
  onPressLeft,
  onPressRight,
  leftIcon = ArrowPointLeftIcon,
  rightIcon = DotsIcon,
  separator = true,
  rightButton,
}: MobileNavHeaderProps) {
  const colors = useContext(ColorThemeContext);

  return (
    <>
      <div className={classNames.navHeader}>
        {!!onPressLeft && (
          <div className={classNames.left}>
            <MBNavigationHeaderButton icon={leftIcon} onPress={onPressLeft} />
          </div>
        )}
        {isString(title) && (
          <div className={classNames.title}>
            <MBTextH4 color={colors.foregroundActive} numberOfLines={1}>
              {title}
            </MBTextH4>
          </div>
        )}
        {!isString(title) && !!title && <div className={classNames.title}>{title}</div>}
        {rightButton && <div className={classNames.right}>{rightButton}</div>}
        {!rightButton && !!onPressRight && (
          <div className={classNames.right}>
            <MBNavigationHeaderButton icon={rightIcon} onPress={onPressRight} />
          </div>
        )}
      </div>
      {!!separator && <MBSeparator />}
    </>
  );
}
